export class CommutingTripSummary {
  constructor(id, employeeId, title, home, work, bicyclePortions, isWorkToHome) {
    this.id = id;
    this.employeeId = employeeId;
    this.title = title;
    this.home = home;
    this.work = work;
    this.bicyclePortions = bicyclePortions;
    this.isWorkToHome = isWorkToHome;
  }
  get bicycleDistance() {
    return this.bicyclePortions.reduce((res, {
      distance
    }) => res + distance, 0);
  }
}
export class CommutingTrip extends CommutingTripSummary {
  constructor(id, employeeId, title, home, work, bicyclePortions, isWorkToHome) {
    super(id, employeeId, title, home, work, bicyclePortions, isWorkToHome);
    this.bicyclePortions = bicyclePortions;
  }
}
export class CommutingTripOccurrence {
  constructor(id, commutingTripId, date, day, direction, certified, manuallyFlagged, compensated, excluded) {
    this.id = id;
    this.commutingTripId = commutingTripId;
    this.date = date;
    this.day = day;
    this.direction = direction;
    this.certified = certified;
    this.manuallyFlagged = manuallyFlagged;
    this.compensated = compensated;
    this.excluded = excluded;
  }
}
export class CommutingTripPotentialOccurrence {
  constructor(id, date, day, direction, candidate, certified, manuallyFlagged, enabled, referenceTrip, commutingTrip, traceId) {
    this.id = id;
    this.date = date;
    this.day = day;
    this.direction = direction;
    this.candidate = candidate;
    this.certified = certified;
    this.manuallyFlagged = manuallyFlagged;
    this.enabled = enabled;
    this.referenceTrip = referenceTrip;
    this.commutingTrip = commutingTrip;
    this.traceId = traceId;
  }
}